import HtmlDataHelper from '@/helpers/HtmlDataHelper';
import SearchDefaults from '@/types/SearchDefaults';

export default class TileTrackerHelper {
  productImpressions: any[] = [];

  promotionImpressions: any[] = [];

  HtmlDataHelper: HtmlDataHelper;

  constructor(HtmlHelper: HtmlDataHelper) {
    this.HtmlDataHelper = HtmlHelper;
  }

  // eslint-disable-next-line class-methods-use-this
  runTracking() {
    document.querySelectorAll('.grid, #slick-slider-external,#slick-slider, #slick-slider-categories, .search-result-list').forEach((value) => {
      value.querySelectorAll('a.search-result:not([data-sent])').forEach((tileElement) => {
        if (HtmlDataHelper.elementInViewport(tileElement as HTMLElement)) {
          this.handleImpressionsSearch(tileElement);
        }
      });
    });
  }

  handleImpressionsSearch(element: any) {
    try {
      const resultType = element.getAttribute('data-type');

      if (resultType === 'product') {
        this.handleProductImpressionSearch(element);
      } else {
        this.handlePromotionImpressionSearch(element);
      }
    } catch (error) {
      console.warn(error);
    }
  }

  handlePromotionImpressionSearch(element: HTMLElement) {
    const key = 0;

    if (this.promotionImpressions[key] === undefined) {
      this.promotionImpressions[key] = [];
    }

    this.promotionImpressions[key].push(HtmlDataHelper.getPromotionData(element));

    if (this.promotionImpressions[key].length >= SearchDefaults.impressionsBatchCounter) {
      this.sendGoogleDataLayer(
        this.preparePromotionData(this.promotionImpressions[key]),
      );
      this.promotionImpressions.length = 0;
    }

    element.setAttribute('data-sent', 'true');
  }

  handleProductImpressionSearch(element: HTMLElement) {
    const key = 0;
    if (this.productImpressions[key] === undefined) {
      this.productImpressions[key] = [];
    }
    const data = HtmlDataHelper.getProductData(element);
    this.productImpressions[key].push(data);

    if (this.productImpressions[key].length >= SearchDefaults.impressionsBatchCounter) {
      this.sendGoogleDataLayer(
        this.prepareProductData(this.productImpressions[key]),
      );
      this.productImpressions.length = 0;
    }

    element.setAttribute('data-sent', 'true');
  }

  clearTracking() {
    this.productImpressions.length = 0;
    this.promotionImpressions.length = 0;
  }

  // eslint-disable-next-line class-methods-use-this
  preparePromotionData(data: any[]) {
    return {
      event: 'eec.promotionView',
      ecommerce: {
        promoView: {
          promotions: data,
        },
      },
    };
  }

  // eslint-disable-next-line class-methods-use-this
  prepareProductData(data: any[]) {
    return {
      event: 'eec.productImpression',
      ecommerce: {
        currencyCode: HtmlDataHelper.getCurrency(),
        impressions: data,
      },
    };
  }

  // eslint-disable-next-line class-methods-use-this
  sendGoogleDataLayer(code: any) {
    if (window.dataLayer !== undefined) {
      window.dataLayer.push(code);
    }
  }

  sendAllData() {
    if (this.productImpressions.length !== 0) {
      this.productImpressions.forEach((element) => {
        if (element !== undefined && element.length > 0) {
          this.sendGoogleDataLayer(this.prepareProductData(element));
        }
      });
    }
    if (this.promotionImpressions.length !== 0) {
      this.promotionImpressions.forEach((element) => {
        if (element !== undefined && element.length > 0) {
          this.sendGoogleDataLayer(this.preparePromotionData(element));
        }
      });
    }
  }
}
